import React, { useState } from 'react';
import { DEFAULT_WINDOW_STYLE } from './Window3D.jsx';
import './windowStyleBox.scss';

// انواع پنجره‌ی قابل‌انتخاب — هر نوع، در Window3D.jsx نحوه‌ی بازشدنِ مخصوصِ خودش را هم دارد
const WINDOW_TYPES = [
  { value: 'sliding', label: 'کشویی' },
  { value: 'casement', label: 'لولاییِ کناری' },
  { value: 'doubleCasement', label: 'دولنگه‌ی لولایی' },
  { value: 'awning', label: 'بازشوِ بالازن' },
  { value: 'hopper', label: 'بازشوِ پایین‌زن' },
  { value: 'fixed', label: 'ثابت (بدون بازشو)' },
];

const MAIN_COLOR_PRESETS = ['#f4f4f2', '#ffffff', '#2f333a', '#8a5a3b', '#5c4433', '#c9a876'];
const ACCENT_COLOR_PRESETS = ['#dce8f0', '#c9dbe6', '#eef3f2', '#d7e2e0', '#e3ecf1'];

// جنسِ قاب — 'paint' یعنی رنگِ واقعی (بافتِ سطحِ رنگ‌شده زیرِ رنگِ انتخابی)؛ بقیه، عکسِ واقعیِ PBR هستند (دقیقاً همان الگوی
// FLOOR_TYPES/COVERING_TYPES در floorStyleBox.jsx/wallStyleBox.jsx)
const FRAME_MATERIAL_TYPES = [
  { value: 'paint', label: 'رنگ' },
  { value: 'woodPine', label: 'چوبِ روشن ✦' },
  { value: 'woodDark', label: 'چوبِ تیره ✦' },
  { value: 'metalBrushed', label: 'فلزِ واقعی ✦' },
];
// جنس‌هایی که عکسِ واقعی‌اند و رنگِ انتخابی رویشان «ضرب» می‌شود
const PHOTO_MATERIALS = ['woodPine', 'woodDark', 'metalBrushed'];

const TABS = [
  { id: 'type', label: 'نوع' },
  { id: 'material', label: 'رنگ و جنس' },
  { id: 'size', label: 'ابعاد' },
];

const WIDTH_MIN_CM = 60;
const WIDTH_MAX_CM = 240;
const HEIGHT_MIN_CM = 40;
const SILL_MIN_CM = 0;
// حداکثرِ ارتفاعِ دیوار، برای وقتی که wallHeightCm در دسترس نیست
const WALL_HEIGHT_FALLBACK = 280;

function ColorField({ label, value, presets, onChange }) {
  return (
    <div className="window-style-box__field">
      {label && <span className="window-style-box__label">{label}</span>}
      <div className="window-style-box__swatches">
        {presets.map((c) => (
          <button
            key={c}
            type="button"
            className={`window-style-box__swatch ${value === c ? 'is-active' : ''}`}
            style={{ background: c }}
            onClick={() => onChange(c)}
          />
        ))}
        <input
          type="color"
          className="window-style-box__custom-color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}

// پنلِ ادیتِ یک پنجره در حالت سه‌بعدی — دقیقاً همان الگوی DoorStyleBox: نوع، رنگ و جنس (رنگ قاب +
// رنگ/تُنِ شیشه)، و ابعاد (عرض/ارتفاع/ارتفاعِ لبه‌ی پایین از کف — سه‌تایی، چون برخلافِ در، پنجره از
// کف شروع نمی‌شود و محلِ قرارگیریِ عمودی‌اش هم قابل‌تنظیم است)
// این چهار نوع، لولا/مفصل دارند و «به‌سمتِ داخل یا بیرون» برایشان معنا دارد؛ کشویی و ثابت ندارند
// (کشویی به‌جای جلو/عقب، به کنار می‌لغزد؛ ثابت اصلاً باز نمی‌شود)
const FACING_TYPES = ['casement', 'doubleCasement', 'awning', 'hopper'];

function WindowStyleBox({
  style,
  defaultWidthCm,
  defaultHeightCm,
  defaultSillCm,
  wallHeightCm,
  onChangeType,
  onChangeColor,
  onChangeAccent,
  onChangeSize,
  onChangeFacing,
  onChangeMaterial,
  onClose,
}) {
  const [activeTab, setActiveTab] = useState('type');
  const s = style || DEFAULT_WINDOW_STYLE;
  const hasFacing = FACING_TYPES.includes(s.type);
  const width = s.widthCm || defaultWidthCm || 120;
  const height = s.heightCm || defaultHeightCm || 120;
  const sill = s.sillCm != null ? s.sillCm : defaultSillCm != null ? defaultSillCm : 90;
  const wallHeight = wallHeightCm || WALL_HEIGHT_FALLBACK;
  // سقفِ اسلایدرها به‌هم وابسته‌اند: ارتفاع نمی‌تواند طوری زیاد شود که از سقف رد شود (با احتسابِ
  // ارتفاعِ لبه‌ی پایین)، و برعکس، لبه‌ی پایین نمی‌تواند طوری بالا برود که با ارتفاعِ فعلی به سقف بخورد
  const heightMaxCm = Math.max(HEIGHT_MIN_CM, wallHeight - sill - 20);
  const sillMaxCm = Math.max(SILL_MIN_CM, wallHeight - height - 20);

  return (
    <div className="window-style-box">
      <div className="window-style-box__header">
        <span>تنظیمات این پنجره</span>
        <button type="button" onClick={onClose}>
          بستن
        </button>
      </div>

      <div className="window-style-box__tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={activeTab === tab.id ? 'is-active' : ''}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'type' && (
        <div className="window-style-box__panel">
          <div className="window-style-box__pills window-style-box__pills--wrap">
            {WINDOW_TYPES.map((t) => (
              <button
                key={t.value}
                type="button"
                className={s.type === t.value ? 'is-active' : ''}
                onClick={() => onChangeType(t.value)}
              >
                {t.label}
              </button>
            ))}
          </div>
          <p className="window-style-box__hint">
            {s.type === 'casement'
              ? 'یک لنگه، از یک لبه لولا می‌خورد؛ پایین‌تر می‌توانید جهتِ بازشدنش را انتخاب کنید.'
              : s.type === 'doubleCasement'
              ? 'دو لنگه از دو لبه لولا می‌خورند و هم‌زمان به یک سمت باز می‌شوند؛ جهتش پایین‌تر قابل‌انتخاب است.'
              : s.type === 'awning'
              ? 'لولا بالای پنجره است؛ لبه‌ی پایین کج می‌شود — مناسبِ بارش که هم بازه هم آب داخل نمی‌ره. جهتش پایین‌تر قابل‌انتخاب است.'
              : s.type === 'hopper'
              ? 'لولا پایینِ پنجره است؛ لبه‌ی بالا کج می‌شود — بیشتر برای تهویه. جهتش پایین‌تر قابل‌انتخاب است.'
              : s.type === 'fixed'
              ? 'این پنجره اصلاً باز نمی‌شود؛ فقط نور و دید دارد، بدون نشانه‌ی بازشدن در حالتِ اول‌شخص.'
              : 'دو لنگه، یکی ثابت و یکی لغزنده که پشتِ لنگه‌ی ثابت سُر می‌خورد — رایج‌ترین نوع.'}
          </p>

          {hasFacing && (
            <div className="window-style-box__field">
              <span className="window-style-box__label">جهتِ بازشدن</span>
              <div className="window-style-box__pills">
                <button type="button" className={s.facing !== 'in' ? 'is-active' : ''} onClick={() => onChangeFacing('out')}>
                  به‌سمتِ بیرون
                </button>
                <button type="button" className={s.facing === 'in' ? 'is-active' : ''} onClick={() => onChangeFacing('in')}>
                  به‌سمتِ داخل
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {activeTab === 'material' && (
        <div className="window-style-box__panel">
          <div className="window-style-box__field">
            <span className="window-style-box__label">جنسِ قاب</span>
            <div className="window-style-box__pills">
              {FRAME_MATERIAL_TYPES.map((m) => (
                <button
                  key={m.value}
                  type="button"
                  className={(s.material || 'paint') === m.value ? 'is-active' : ''}
                  onClick={() => onChangeMaterial(m.value)}
                >
                  {m.label}
                </button>
              ))}
            </div>
          </div>
          <ColorField
            label={PHOTO_MATERIALS.includes(s.material) ? 'رنگ قاب (روی عکسِ واقعی اعمال می‌شود)' : 'رنگ قاب'}
            value={s.color || '#f4f4f2'}
            presets={MAIN_COLOR_PRESETS}
            onChange={onChangeColor}
          />
          {PHOTO_MATERIALS.includes(s.material) && (
            <p className="window-style-box__hint">
              این جنس یک عکسِ واقعیِ {s.material === 'metalBrushed' ? 'فلز' : 'چوب'} است؛ جزئیات از خودِ عکس می‌آید.
              سفید = رنگِ طبیعیِ خودِ عکس؛ برای تیره‌تر/رنگی‌کردن، فقط «رنگ قاب» را تغییر بده.
            </p>
          )}
          <ColorField label="رنگ/تُنِ شیشه" value={s.accent || '#dce8f0'} presets={ACCENT_COLOR_PRESETS} onChange={onChangeAccent} />
        </div>
      )}

      {activeTab === 'size' && (
        <div className="window-style-box__panel">
          <div className="window-style-box__field">
            <span className="window-style-box__label">عرض پنجره: {width} سانتی‌متر</span>
            <input
              type="range"
              min={WIDTH_MIN_CM}
              max={WIDTH_MAX_CM}
              step={5}
              value={width}
              onChange={(e) => onChangeSize({ widthCm: Number(e.target.value) })}
              className="window-style-box__slider"
            />
          </div>
          <div className="window-style-box__field">
            <span className="window-style-box__label">ارتفاع پنجره: {height} سانتی‌متر</span>
            <input
              type="range"
              min={HEIGHT_MIN_CM}
              max={heightMaxCm}
              step={5}
              value={Math.min(height, heightMaxCm)}
              onChange={(e) => onChangeSize({ heightCm: Number(e.target.value) })}
              className="window-style-box__slider"
            />
          </div>
          <div className="window-style-box__field">
            <span className="window-style-box__label">ارتفاعِ لبه‌ی پایین از کف: {sill} سانتی‌متر</span>
            <input
              type="range"
              min={SILL_MIN_CM}
              max={sillMaxCm}
              step={5}
              value={Math.min(sill, sillMaxCm)}
              onChange={(e) => onChangeSize({ sillCm: Number(e.target.value) })}
              className="window-style-box__slider"
            />
          </div>
          <p className="window-style-box__hint">
            تغییرِ هرکدام از این سه مقدار، اندازه/جای بازشوی برش‌خورده از دیوار را هم به‌روز می‌کند.
          </p>
        </div>
      )}
    </div>
  );
}

export default WindowStyleBox;